import React from 'react';
import { Modal, Button, Form, Input, Select } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import validator from 'validator';
import EventTimeSelector from '../EventTimeSelector/EventTimeSelectorComponent';
import { toInstant } from '../../Utility/proposeLink';
import './CreateMeetingComponent.scss';

const FormItem = Form.Item;
const messages = defineMessages({
  selectTime: {
    id: 'CreateMeeting.Message.SelectTime',
    defaultMessage: 'Please Select Time',
  },
  selectDate: {
    id: 'CreateMeeting.Message.SelectDate',
    defaultMessage: 'Please Select Date',
  },
  createMeeting: {
    id: 'CreateMeeting.CreateMeeting',
    defaultMessage: 'Create meeting',
  },
  editMeeting: {
    id: 'CreateMeeting.EditMeeting',
    defaultMessage: 'Edit',
  },
  createTitle: {
    id: 'CreateMeeting.Title.Create',
    defaultMessage: 'Create a new meeting',
  },
  proposeTitle: {
    id: 'CreateMeeting.Title.Propose',
    defaultMessage: 'Propose a new time',
  },
  editTitle: {
    id: 'CreateMeeting.Title.Edit',
    defaultMessage: 'Edit invite',
  },
  submitCreate: {
    id: 'CreateMeeting.Submit.Create',
    defaultMessage: 'Send',
  },
  submitEdit: {
    id: 'CreateMeeting.Submit.Edit',
    defaultMessage: 'Send',
  },
  submitPropose: {
    id: 'CreateMeeting.Submit.Propose',
    defaultMessage: 'Propose',
  },
  inputSubject: {
    id: 'CreateMeeting.Message.InputSubject',
    defaultMessage: 'Please add subject',
  },
  inputLocation: {
    id: 'CreateMeeting.Message.InputLocation',
    defaultMessage: 'Please add location',
  },
  inputEmail: {
    id: 'CreateMeeting.Message.InputEmail',
    defaultMessage: 'Please add email',
  },
  inputBody: {
    id: 'CreateMeeting.Message.InputBody',
    defaultMessage: 'Please add body',
  },
  writeSubject: {
    id: 'CreateMeeting.Placholder.WriteSubject',
    defaultMessage: 'Write',
  },
  subject: {
    id: 'CreateMeeting.Label.Subject',
    defaultMessage: 'Subject',
  },
  time: {
    id: 'CreateMeeting.Label.Time',
    defaultMessage: 'Time',
  },
  duration: {
    id: 'CreateMeeting.Label.Duration',
    defaultMessage: 'Duration',
  },
  location: {
    id: 'CreateMeeting.Label.Location',
    defaultMessage: 'Location',
  },
  email: {
    id: 'CreateMeeting.Label.Email',
    defaultMessage: 'Required Attendees',
  },
  optionalEmail: {
    id: 'CreateMeeting.Label.OptionalEmail',
    defaultMessage: 'Optional Attendees',
  },
  body: {
    id: 'CreateMeeting.Label.Body',
    defaultMessage: 'Body',
  },
  addSubject: {
    id: 'CreateMeeting.Placeholder.AddSubject',
    defaultMessage: 'Add a title for the event',
  },
  addLocation: {
    id: 'CreateMeeting.Placeholder.AddLocation',
    defaultMessage: "Add the recipient's contact no. or a physical location name",
  },
  addBody: {
    id: 'CreateMeeting.Placeholder.AddBody',
    defaultMessage: 'Make this event meaningful. Add an agenda or particulars relevant to it',
  },
  datePassed: {
    id: 'CreateMeeting.Message.DatePassed',
    defaultMessage: 'This date has passed',
  },
  timePassed: {
    id: 'CreateMeeting.Message.TimePassed',
    defaultMessage: 'This time has passed',
  },
  sameTimeAsProposal: {
    id: 'CreateMeeting.Message.SameTimeAsProposal',
    defaultMessage: 'It is same as previous time.',
  },
  addEmail: {
    id: 'CreateMeeting.Message.AddEmail',
    defaultMessage: 'Recipient Email ID',
  },
});


function getInvalidEmails(emails) {
  const invalidEmails = emails.filter(email => !validator.isEmail(email, {allow_ip_domain: false}));
  return invalidEmails;
}


function formatErrorMessage (emailIds, type) {
  let message = [];
  if(emailIds.length === 1) {
    message = [emailIds.join(''), (type === 'invalid') ? ` is an invalid email address` : ` exists in ${type} emails`];
  }
  else {
    message = [
      emailIds.slice(0, -1).join(', '),
        ' and ',
      emailIds.slice(-1),
      (type === 'invalid') ? ' are invalid email addresses' : ` exist in ${type} emails`
    ];
  }
  return message;
}

class CreateMeetingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.validateDate = this.validateDate.bind(this);
    this.validateTime = this.validateTime.bind(this);
    this.validateEmails = this.validateEmails.bind(this);
    this.styleEmailTags = this.styleEmailTags.bind(this);
  }

  styleEmailTags = (menuNode, props) => {
    const inputProps = props;
    const tagChildren =
      props.children.props.children.props.children[0].props.children[1].props.children;
    if (tagChildren.length > 0) {
      for (let i = 0; i < tagChildren.length - 1; i += 1) {
        inputProps.children.props.children.props.children[0].props.children[1].props.children[
          i
        ] = React.cloneElement(
          props.children.props.children.props.children[0].props.children[1].props.children[i],
          {
            ...props.children.props.children.props.children[0].props.children[1].props.children[i]
              .props,
            style: {
              ...props.children.props.children.props.children[0].props.children[1].props.children[i]
                .props.style,
              height: '22px',
              fontSize: '12px',
              borderRadius: '11px',
            },
            children: [
              ...props.children.props.children.props.children[0].props.children[1].props.children[i]
                .props.children,
            ],
          }
        );
      }
    }
    return <div>{menuNode}</div>;
  }

  validateEmails (rule, values, callback, isOptional) {
    const emailType = (isOptional) ? 'required' : 'optional';
    const {form} = this.props;
    const emailIds = form.getFieldValue(`${emailType}EmailIds`);
    const invalidEmails = getInvalidEmails(values);
    if (invalidEmails.length === 0) {
      const commonEmailIds = _.intersection(values, emailIds);
      if(commonEmailIds.length === 0){
        callback();
      }
      else {
        const message = formatErrorMessage(commonEmailIds, emailType);
        callback(message);
      }
    } else {
      const message = formatErrorMessage(invalidEmails, 'invalid');
      callback(message);
    }
  };


  validateTime(rule, value, callback) {
    const { form, event, type } = this.props;
    const allDayChecked = form.getFieldValue('allDay');
    if (type === 'update' && !allDayChecked) {
      const selectedDate = form.getFieldValue('datePicker');
      let date = moment().format('YYYY-MM-DD');
      if (selectedDate) {
        date = moment(selectedDate).format('YYYY-MM-DD');
      }
      const time = moment(value).format('HH:mm');
      if (!value) {
        callback();
      } else if (
        moment(toInstant(event.StartTime)).format('YYYY-MM-DD HH:mm') === moment(`${date} ${time}`).format('YYYY-MM-DD HH:mm')
      ) {
        callback(<FormattedMessage {...messages.sameTimeAsProposal} />);
      } else if (moment(`${date} ${time}`).isBefore(moment(), 'minute')) {
        callback(<FormattedMessage {...messages.timePassed} />);
      } else if (selectedDate) {
        form.setFieldsValue({ datePicker: moment(`${date} ${time}`) });
        callback();
      }
    } else {
      callback();
    }
  }

  validateDate(rule, value, callback) {
    const { form, type, event } = this.props;
    const allDayChecked = form.getFieldValue('allDay');
    if (type === 'update') {
      const selectedTime = form.getFieldValue('timePicker');
      const date = moment(value).format('YYYY-MM-DD');
      let time = moment().format('HH:mm');
      if (selectedTime) {
        time = moment(selectedTime).format('HH:mm');
      }
      if (!value) {
        callback();
      } else if (allDayChecked && moment(toInstant(event.StartTime)).isSame(moment(date), 'day')) {
        callback(<FormattedMessage {...messages.sameTimeAsProposal} />);
      } else if (moment(`${date} ${time}`).isBefore(moment(), 'day')) {
        callback(<FormattedMessage {...messages.datePassed} />);
      } else if (selectedTime) {
        form.setFieldsValue({ timePicker: moment(`${date} ${time}`) });
        callback();
      }
    } else {
      callback();
    }
  }




  render() {
    const { TextArea } = Input;
    const {
      form,
      type,
      event,
      candidates,
      showModal,
      title,
      visible,
      handleOk,
      handleCancel,
      intl,
      disable,
      onClickMarked,
      defaultDuration,
      handleEventTimeChange,
      eventsOverlapCount,
    } = this.props;
    let modalCssClassName;
    let okText;
    let emailIds = [];
    let optionalEmailIds = [];
    let modalTitle;

    if (type === 'update') {
      modalTitle = <FormattedMessage {...messages.proposeTitle} />;
    } else if (type === 'edit') {
      modalTitle = <FormattedMessage {...messages.editTitle} />;
    } else {
      modalTitle = <FormattedMessage {...messages.createTitle} />;
    }

    if (type === 'update') {
      okText = <FormattedMessage {...messages.submitPropose} />;
    } else if (type === 'edit') {
      okText = <FormattedMessage {...messages.submitEdit} />;
    } else {
      okText = <FormattedMessage {...messages.submitCreate} />;
    }

    if (type === 'update') {
      modalCssClassName = 'propose-modal';
    } else {
      modalCssClassName = 'create-modal';
    }
    if (event.Attendees !== [] || event.Attendees !== undefined) {
      emailIds = candidates.filter(email => email.role === 'REQ-PARTICIPANT').map(email => email.email);
      optionalEmailIds = candidates.filter(email => email.role === 'OPT-PARTICIPANT').map(email => email.email);
    }
    const newConfigTime = {
      initialValue: type === 'update' || type === 'edit' ? moment(toInstant(event.StartTime)) : moment(),
      rules: [
        { type: 'object', required: true, message: <FormattedMessage {...messages.selectTime} /> },
        { validator: this.validateTime },
      ],
    };
    const newConfigDate = {
      initialValue: type === 'update' || type === 'edit' ? moment(toInstant(event.StartTime)) : moment(),
      rules: [
        { type: 'object', required: true, message: <FormattedMessage {...messages.selectDate} /> },
        { validator: this.validateDate },
      ],
    };
    const oldConfigTime = {
      initialValue: type === 'update' || type === 'edit' ? moment(toInstant(event.StartTime)) : moment(),
    };
    const oldConfigDate = {
      initialValue: type === 'update' || type === 'edit' ? moment(toInstant(event.StartTime)) : moment(),
    };

    const decoratorsForNewTime = {
      datePicker: 'datePicker',
      timePicker: 'timePicker',
      allDay: 'allDay',
      timeSpan: 'timeSpan',
      slotTimeUnit: 'slotTimeUnit',
    };
    const decoratorsForOldTime = {
      datePicker: 'datePicker1',
      timePicker: 'timePicker1',
      allDay: 'allDay1',
      timeSpan: 'timeSpan1',
      slotTimeUnit: 'slotTimeUnit1',
    };

    return (
      <div>
        <Button
          className={`button ${type === 'update' ? 'propose-button' : 'create-meeting-button'}`}
          onClick={showModal}
        >
          <span>{type === 'update' || type === 'edit' ? title : <FormattedMessage {...messages.createMeeting} />}</span>
        </Button>

        <Modal
          title={modalTitle}
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          width="717px"
          closable={false}
          className={modalCssClassName}
          okText={okText}
        >
          <Form onSubmit={handleOk} hideRequiredMark>
            <FormItem
              label={<FormattedMessage {...messages.subject} />}
              colon={false}
              style={{
                marginBottom: 24,
                marginTop: 22,
                fontWeight: 500,
                fontFamily: 'Roboto',
              }}
            >
              {form.getFieldDecorator('subject', {
                initialValue: event.Summary,
                rules: [
                  {
                    required: true,
                    message: <FormattedMessage {...messages.inputSubject} />,
                    whitespace: true,
                  },
                ],
              })(<Input placeholder={intl.formatMessage({ ...messages.addSubject })} className="subject-input" />)}
            </FormItem>
            {type === 'update' ? (
              <EventTimeSelector
                disable={disable}
                type={type}
                time="old"
                decorators={decoratorsForOldTime}
                getFieldDecorator={form.getFieldDecorator}
                onClickMarked={onClickMarked}
                configDate={oldConfigDate}
                configTime={oldConfigTime}
                defaultDuration={defaultDuration}
              />
            ) : null}
            <EventTimeSelector
              disable={disable}
              type={type}
              time="new"
              decorators={decoratorsForNewTime}
              getFieldDecorator={form.getFieldDecorator}
              onClickMarked={onClickMarked}
              configDate={newConfigDate}
              configTime={newConfigTime}
              defaultDuration={defaultDuration}
              handleEventTimeChange={handleEventTimeChange}
              eventsOverlapCount={eventsOverlapCount}
            />
            <FormItem
              label={<FormattedMessage {...messages.location} />}
              colon={false}
              style={{ marginBottom: 24, fontWeight: 500, fontFamily: 'Roboto' }}
            >
              {form.getFieldDecorator('location', {
                initialValue: event.Location,
                rules: [
                  {
                    required: true,
                    message: <FormattedMessage {...messages.inputLocation} />,
                    whitespace: true,
                  },
                ],
              })(<Input placeholder={intl.formatMessage({ ...messages.addLocation })} className="location-input" />)}
            </FormItem>

            <FormItem
              label={<FormattedMessage {...messages.email} />}
              colon={false}
              style={{ marginBottom: 24, fontWeight: 500, fontFamily: 'Roboto' }}
            >
              {form.getFieldDecorator('requiredEmailIds', {
                initialValue: emailIds ? emailIds.filter(email => email !== '') : [],
                display: 'block',
                rules: [
                  {
                    required: true,
                    message: <FormattedMessage {...messages.inputEmail} />,
                  },
                  { validator: (rule, value, callback) => this.validateEmails(rule, value, callback, false)},
                ],
              })(
                <Select
                  mode="tags"
                  key="required-emails"
                  className="email-input"
                  placeholder="Add required emails"
                  style={{ width: '100%' }}
                  dropdownStyle={{ display: 'none' }}
                  tokenSeparators={[';', ',', ' ']}
                  dropdownRender={this.styleEmailTags}
                />
              )}
            </FormItem>

            <FormItem
              label={<FormattedMessage {...messages.optionalEmail} />}
              colon={false}
              style={{ marginBottom: 24, fontWeight: 500, fontFamily: 'Roboto' }}
            >
              {form.getFieldDecorator('optionalEmailIds', {
                initialValue: optionalEmailIds ? optionalEmailIds.filter(email => email !== '') : [],
                display: 'block',
                rules: [{ validator: (rule, value, callback) => this.validateEmails(rule, value, callback, true) }],
              })(
                <Select
                  mode="tags"
                  key="optional-emails"
                  className="email-input"
                  placeholder="Add optional emails"
                  style={{ width: '100%' }}
                  dropdownStyle={{ display: 'none' }}
                  tokenSeparators={[';', ',', ' ']}
                  dropdownRender={this.styleEmailTags}
                />
              )}
            </FormItem>

            <FormItem
              label={<FormattedMessage {...messages.body} />}
              colon={false}
              style={{ margin: 'none', fontWeight: 500, fontFamily: 'Roboto' }}
            >
              {form.getFieldDecorator('body', {
                initialValue: event.Description,
                rules: [
                  {
                    required: true,
                    message: <FormattedMessage {...messages.inputBody} />,
                    whitespace: true,
                  },
                ],
              })(<TextArea className="body-textarea" placeholder={intl.formatMessage({ ...messages.addBody })} />)}
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }
}

CreateMeetingComponent.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func,
    getFieldDecorator: PropTypes.func,
    setFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func,
  }).isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onClickMarked: PropTypes.func.isRequired,
  handleEventTimeChange: PropTypes.func.isRequired,
  disable: PropTypes.bool.isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  defaultDuration: PropTypes.number,
  candidates: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      email: PropTypes.string,
      role: PropTypes.string,
    })
  ),
  eventsOverlapCount: PropTypes.number,
  event: PropTypes.shape({
    Summary: PropTypes.string,
    Description: PropTypes.string,
    Location: PropTypes.string,
    Attendees: PropTypes.arrayOf(
      PropTypes.shape({
        Email: PropTypes.string,
      })
    ),
    StartTime: PropTypes.string,
    EventId: PropTypes.string,
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

CreateMeetingComponent.defaultProps = {
  eventsOverlapCount: 0,
  type: '',
  title: '',
  candidates: [],
  event: {
    Summary: '',
    Description: '',
    Location: '',
    Attendees: [],
    StartTime: moment().format(),
    EventId: '',
  },
  defaultDuration: undefined,
};

export default injectIntl(CreateMeetingComponent);
export {getInvalidEmails};
